module.exports = "/static/assets/04e28ba12fe914cf4f131dcb85ae82d6.svg";